<div class="fluid-container">
  <h2 class="card-header " style="margin-bottom: 15px;text-align: center;color: #1a2152;text-decoration:underline;">
    Patient
    Call Center Reservation</h2>

  <form class="card-header border" [formGroup]="patReservationForm" novalidate>
    <div class="row">
      <name-component #name [namingTranslationSetting]="5" [nameAllowNumber]="true"></name-component>
    </div>
    <!-- <div class="row">
      <div class="col-4">
        <label for="titleCode">
          {{ 'title' | translate }}
        </label>

        <select class="form-control  form-control-sm " formControlName="titleCode">
          <option></option>
          <option *ngFor="let title of titleCodeList" [value]="title.code">
            {{title.nameAr}}--{{title.nameEn}}
          </option>
        </select>

      </div>
      <div class="col-2">
        <label>{{ "الاسم الاول" | translate }}</label>
        <input class="form-control form-control-sm" type="text" formControlName="fname" />
      </div>
      <div class="col-2">
        <label>{{ "الاسم الثاني" | translate }}</label>

        <input class="form-control form-control-sm" type="text" formControlName="sname" />
      </div>
      <div class="col-2">
        <label>{{ "الاسم الثالث" | translate }}</label>
        <input class="form-control form-control-sm" type="text" formControlName="tname" />
      </div>
      <div class="col-2">
        <label>{{ "الاسم الاخير" | translate }}</label>
        <input class="form-control form-control-sm" type="text" formControlName="lname" />
      </div>
    </div> -->
    <div class="row">
      <!-- <div class="col">
        <label for="birthDate">
            {{'BIRTHDATE' | translate}}
        </label>
        <div class="input-group input-group-sm">
            <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                formControlName="birthDateNgb" tabindex="13" ngbDatepicker
                #birthDate="ngbDatepicker" [minDate]="{'year':1900,'month':1,'day':1}"
                [maxDate]="today" (navigate)="getHigriDate();calcage($event)"
                (change)=" getHigriDate();calcage($event)">
            <div class="input-group-addon" (click)="birthDate.toggle()">
                <i class="fa fa-calendar"></i>
            </div>
        </div>
    </div> -->

      <div class="form-sm-group col-md-3">
        <sanabel-selectize appcode="1" [tabindex]="7" #selectizeGender [excludedCodes]="'3'" formControlName="gender">
        </sanabel-selectize>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <sanabel-selectize appcode="1013" #nationalitySelectize required="false"
            formControlName="nationalityId" [tabindex]="9">
          </sanabel-selectize>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <label>{{ "MOBILENUMBER" | translate }}</label>
          <input class="form-control form-control-sm" tabindex="6" type="text" maxlength="11" formControlName="mobile"
            (change)="onMobileKeyUp()" />
        </div>

        <div *ngIf="
     patReservationForm.controls['mobile'].errors &&
          (patReservationForm.controls['mobile'].dirty ||
          patReservationForm.controls['mobile'].touched)
        " class="alert alert-danger"></div>
      </div>
      <div class="col-3">
        <label class="small">{{'HOWTOREACHUS' | translate}}</label>
        <sanabel-selectize appcode="315" [tabindex]="15" formControlName="howToReachUs" [simpleView]="true">
        </sanabel-selectize>

      </div>
    </div>
  </form>

  <div class="row">
    <div class="col text-center">
      <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="savePatientReservation()"></btns-ctrl>
    </div>
  </div>
</div>